// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Bundle, BundleProcessingStatus, BundleProcessingStatusValues, BundleSummary, Release } from "generated/mos/org/getty/publish";
import { Page } from "generated/mos/pagination";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar, ensureScalarRepeated, stripTypePropertyDeep } from "generated/webrpc";

export namespace ListBundleSummariesRequest {
  export const refName = "mos.org.getty.publish_access.ListBundleSummariesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
  }
  export const defaults: Entity = {
    type: refName,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListBundleSummariesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      return out as any as Entity;
    }
  }();
}

export namespace ListBundleSummariesResponse {
  export const refName = "mos.org.getty.publish_access.ListBundleSummariesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly summaries: ReadonlyArray<BundleSummary.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    summaries: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["summaries"] = [];
      for (const item of v.summaries) {
        obj["summaries"].push(BundleSummary.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListBundleSummariesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["summaries"] = decodeMessageRepeated(ctx, BundleSummary.codec, v["summaries"], "summaries");
      return out as any as Entity;
    }
  }();
}

export namespace ListBundlesRequest {
  export const refName = "mos.org.getty.publish_access.ListBundlesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListBundlesRequest.ByProcessingStatus.Entity | ListBundlesRequest.ByRef.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.publish_access.ListBundlesRequest.ByProcessingStatus") {
            obj["byProcessingStatus"] = ListBundlesRequest.ByProcessingStatus.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.publish_access.ListBundlesRequest.ByRef") {
            obj["byRef"] = ListBundlesRequest.ByRef.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.publish_access.ListBundlesRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListBundlesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byProcessingStatus"] !== undefined) {
          out["filter"] = ctx.decode(ListBundlesRequest.ByProcessingStatus.codec, v["byProcessingStatus"], "byProcessingStatus");
        }
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListBundlesRequest.ByRef.codec, v["byRef"], "byRef");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByProcessingStatus {
    export const refName = "mos.org.getty.publish_access.ListBundlesRequest.ByProcessingStatus" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly processingStatuses: ReadonlyArray<BundleProcessingStatus>,
    }
    export const defaults: Entity = {
      type: refName,
      processingStatuses: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListBundlesRequest.ByProcessingStatus");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        {
          const evs = ensureScalarRepeated(ctx, v["processingStatuses"], "string").map(i => i || defaults["processingStatuses"]);
          for (const ev of evs) {
            if (!BundleProcessingStatusValues.has(ev as any)) {
              throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.publish.BundleProcessingStatus`);
            }
          }
          out["processingStatuses"] = evs as any;
        }
        return out as any as Entity;
      }
    }();
  }

  export namespace ByRef {
    export const refName = "mos.org.getty.publish_access.ListBundlesRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly bundleRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.publish.Bundle', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      bundleRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListBundlesRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["bundleRefs"] = v["bundleRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListBundlesResponse {
  export const refName = "mos.org.getty.publish_access.ListBundlesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly bundles: ReadonlyArray<Bundle.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    bundles: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["bundles"] = [];
      for (const item of v.bundles) {
        obj["bundles"].push(Bundle.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListBundlesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["bundles"] = decodeMessageRepeated(ctx, Bundle.codec, v["bundles"], "bundles");
      return out as any as Entity;
    }
  }();
}

export namespace ListReleasesRequest {
  export const refName = "mos.org.getty.publish_access.ListReleasesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly page: Page.Entity | undefined,
    readonly sortOrder: ListReleasesRequest.SortOrder,
  }
  export const defaults: Entity = {
    type: refName,
    page: undefined,
    sortOrder: "SORT_DEFAULT",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListReleasesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["page"] = ctx.decode(Page.codec, v["page"], "page");
      {
        const ev = ensureScalar(ctx, v["sortOrder"], "string") || defaults["sortOrder"];
        if (!ListReleasesRequest.SortOrderValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.publish_access.ListReleasesRequest.SortOrder`);
        }
        out["sortOrder"] = ev as any;
      }
      return out as any as Entity;
    }
  }();
  export const SortOrderValues = new Set([
    'SORT_DEFAULT' as const,
    'SORT_CREATED_DESC' as const,
  ]);
  export type SortOrder = typeof SortOrderValues extends Set<infer U> ? U : never;

}

export namespace ListReleasesResponse {
  export const refName = "mos.org.getty.publish_access.ListReleasesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly releases: ReadonlyArray<Release.Entity>,
    readonly nextPage: Page.Entity | undefined,
    readonly totalItems: number,
  }
  export const defaults: Entity = {
    type: refName,
    releases: [],
    nextPage: undefined,
    totalItems: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["releases"] = [];
      for (const item of v.releases) {
        obj["releases"].push(Release.codec.encode(item));
      }
      obj["nextPage"] = Page.codec.encode(v.nextPage);
      obj["totalItems"] = v.totalItems;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_access.ListReleasesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["releases"] = decodeMessageRepeated(ctx, Release.codec, v["releases"], "releases");
      out["nextPage"] = ctx.decode(Page.codec, v["nextPage"], "nextPage");
      out["totalItems"] = ensureScalar(ctx, v["totalItems"], "number");
      return out as any as Entity;
    }
  }();
}

